
import { Options, Vue } from "vue-class-component"; //基本需要\
import {
  dispatchGetSgameSkinOption,
  dispatchGetSgameSkinTabList,
  dispatchGetSgameSkinListGet,
  dispatchUpdateSkinTab,
  dispatchDeleteSkinTab,
  //dispatchGetSgameSkinData,
  dispatchBathchSkinExport,
} from "@/store/performance/actions";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  readGetSgameSkinOption,
  readGetSgameSkinList,
  readGetSgameSkinData,
} from "@/store/performance/getters";
import { store } from "@/store";
import { ElMessage } from "element-plus";
import axios from 'axios'

 

export default class BatchGenerateSkins extends Vue {
  filter = false
  skin_data = []
  async onFilterChange(val) {
    await this.dispatchGetSgameSkinData(store, {
      project: this.localProject,
      skin_tab_id: this.tag_id
        ? this.tag_id
        : this.tag_list.filter((v) => v.tab_name == this.tag_name)[0].id,
      filter: val ? 'show1' : '',
    });
    this.get_skin();
  }

  async dispatchGetSgameSkinData(store, params) {
    const {data} = await axios('/report/batch_skin_data/', {params})
    this.skin_data = data
  }

  genderOptions = {
    0: '默认',
    1: '男',
    2: '女',
  }

  // public get skin_data() {
  //   return readGetSgameSkinData(store);
  // }
  public;
  public extractBracketContents(input) {
    const regex = /(.+?)(（.+?）)/;
    const matches = input.match(regex);

    if (matches) {
      const textOutsideBrackets = matches[1];
      const textInsideBrackets = matches[2];
      return { textOutsideBrackets, textInsideBrackets };
    } else {
      console.log("未找到匹配的括号内容。");
      return null;
    }
  }
  public mergeCells({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4) {
      const rowCount = this.skin_data_list.filter((item) => item.id === row.id && item.gender === row.gender)
        .length;
      if (rowCount > 1) {
        const isFirstRow =
          this.skin_data_list.findIndex((item) => item.id === row.id && item.gender === row.gender) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 5) {
      const rowCount = this.skin_data_list.filter(
        (item) => item.id === row.id && item.scene === row.scene && item.gender === row.gender
      ).length;

      if (rowCount > 1) {
        const isFirstRow =
          this.skin_data_list.findIndex(
            (item) => item.id === row.id && item.scene === row.scene && item.gender === row.gender
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 6) {
      const rowCount = this.skin_data_list.filter(
        (item) =>
          item.id === row.id &&
          item.scene === row.scene &&
          item.model === row.model && 
          item.gender === row.gender
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.skin_data_list.findIndex(
            (item) =>
              item.id === row.id &&
              item.scene === row.scene &&
              item.model === row.model && 
              item.gender === row.gender
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public skin_data_list = [];
  public get_skin() {
    let list = [];
    this.skin_data_list = [];
    this.skin_data.forEach((v) => {
      if (v["局内"]) {
        for (let i in v["局内"]) {
          v["局内"][i]["/"].forEach((n) => {
            list.push({
              hero_name: v.hero_name,
              id: v.id,
              gender: v.gender,
              suitname: v.suitname,

              skin_name: v.skin_name,
              scene: "局内",
              model: i,
              action: "/",
              data: n,
            });
          });
        }
      }
      if (v["局外"]) {
        for (let i in v["局外"]) {
          this.kingAction.forEach((x) => {
            if (v["局外"][i][x.label]) {
              v["局外"][i][x.label].forEach((n) => {
                list.push({
                  hero_name: v.hero_name,
                  id: v.id,
                  gender: v.gender,
                  suitname: v.suitname,

                  skin_name: v.skin_name,
                  scene: "局外",
                  model: i,
                  action: x.label,
                  data: n,
                });
              });
            }
          });
          //  v['局外'][i]['/'].forEach(n=>{
          //    this.skin_data_list.push({
          //      hero_name:v.hero_name,
          //      id:v.id,

          //      skin_name:v.skin_name,
          //      scene:'局外',
          //      device:i,
          //      action:'/',
          //      data:n

          //    })
          //  })
        }
      }
    });
    if (this.conclusion == "不达标") {
      this.skin_data_list = list.filter((v) => v.data.risk == "不达标");
    } else if (this.conclusion == "达标") {
      this.skin_data_list = list.filter((v) => v.data.risk == "达标");
    } else {
      this.skin_data_list = list;
    }
  }
  public kingAction = [
    { label: "进场", value: "come" },
    { label: "站定", value: "idle" },
  ];
  public async deleteBtn() {
    this.tree_show = false;
    this.out_loading = true;
    await dispatchDeleteSkinTab(store, {
      project: this.localProject,
      id: this.tag_id,
    });
    await dispatchGetSgameSkinListGet(store, {
      project: this.localProject,
    });

    ElMessage.success({
      message: "删除标签成功",
      showClose: true,
      type: "success",
    });
    if (this.tag_list?.length == 0) {
      this.tree_show = true;
      this.text_cont = "";
    } else {
      this.tag_id = this.tag_list[0].id;
      this.text_cont = "展示";
      await this.dispatchGetSgameSkinData(store, {
        project: this.localProject,
        skin_tab_id: this.tag_id,
        filter: this.filter ? 'show1' : '',
      });
      this.get_skin();
    }

    this.out_loading = false;
  }
  public localProject = 34;
  public fixed = false;
  public tree_show = false;
  public async treeShowBtn(item) {
    this.out_loading = true;
    this.tree_show = false;
    this.tag_id = item.id;
    this.text_cont = "展示";
    await this.dispatchGetSgameSkinData(store, {
      project: this.localProject,
      skin_tab_id: item.id,
      filter: this.filter ? 'show1' : '',
    });
    this.$router.push({query: {...this.$route.query, skin_tab_id: item.id}})
    this.get_skin();
    this.out_loading = false;
  }
  public exportData() {
    let b = (this as any).$message({
      //Message 消息提示
      message: "导出中,请耐心等待....",
      showClose: true,
      duration: 0,
    });

    const response_data = dispatchBathchSkinExport(store, {
      project: this.localProject,

      skin_tab_id: this.tag_id,
    });

    response_data.then((value) => {
      var elink = document.createElement("a");
      elink.download =
        "皮肤页签-" +
        this.tag_list.filter((v) => v.id == this.tag_id)[0].tab_name +
        ".xlsx";
      elink.style.display = "none";
      var blob = new Blob([value], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });

      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      b.close();
    });
  }
  public conclusion_list = ["不达标", "达标", "全量"];
  public conclusion = "不达标";
  public async mounted() {
    this.out_loading = true;
    window.addEventListener("scroll", this.handleScroll);
    dispatchGetSgameSkinOption(store, {
      project: this.localProject,
    });
    await dispatchGetSgameSkinListGet(store, {
      project: this.localProject,
    });
    if (this.tag_list?.length == 0) {
      this.tree_show = true;
      this.text_cont = "";
    } else {
      const skin_tab_id = this.$route.query.skin_tab_id
      this.tag_id = skin_tab_id ? skin_tab_id : this.tag_list[0].id
      this.text_cont = '展示'

      await this.dispatchGetSgameSkinData(store, {
        project: this.localProject,
        skin_tab_id: this.tag_id,
        filter: this.filter ? 'show1' : '',
      });
      this.get_skin();
    }

    this.out_loading = false;
  }
  public clearBtn() {
    this.checkedNodes = [];
    this.$nextTick(() => {
      (this.$refs.tree as any).setCheckedKeys([]);

      this.box_loading = false;
    });
  }
  public tag_id = "";
  public creatTag() {
    this.box_loading = true;
    this.tree_show = true;
    this.tag_name = "";
    (this.text_cont = ""), (this.valueTime = []);
    this.tag_id = "";
    this.$nextTick(() => {
      (this.$refs.tree as any).setCheckedKeys([]);

      this.box_loading = false;
    });
  }
  public treeBtn(item) {
    this.box_loading = true;
    this.tree_show = true;
    this.text_cont = "编辑";
    this.tag_name = item.tab_name;
    this.valueTime = [item.start_date, item.end_date];
    this.tag_id = item.id;
    this.$nextTick(() => {
      (this.$refs.tree as any).setCheckedKeys(item.skin_list);

      // this.box_loading=false
    });

    this.box_loading = false;
  }
  public get tag_list() {
    return readGetSgameSkinList(store);
  }
  handleFilter() {
    (this.$refs.tree as any).filter(this.filter_input);
  }
  filterNode(value, data) {
    if (!value) return true;
    return data.label.toLowerCase().includes(value.toLowerCase());
  }
  public valueTime = [];
  public tag_name = "";
  public filter_input = "";
  handleRemove(item) {
    // 从 checkedNodes 中移除该节点
    this.checkedNodes = this.checkedNodes.filter((node) => node.id !== item.id);

    // 在 el-tree 中取消选中该节点
    (this.$refs.tree as any).setChecked(item, false, true);
  }
  public beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  public conclusionChange() {
    this.get_skin();
  }
  public async confirm() {
    let startTimeAll = "";
    let endTimeAll = "";
    let errorList = [];
    if (this.valueTime) {
      startTimeAll =
        dateConversion(this.valueTime[0]) == "-"
          ? ""
          : dateConversion(this.valueTime[0]).split(" ")[0];
      endTimeAll =
        dateConversion(this.valueTime[1]) == "-"
          ? ""
          : dateConversion(this.valueTime[1]).split(" ")[0];
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }
    if (!startTimeAll) {
      errorList.push("时间");
    }
    if (!this.tag_name) {
      errorList.push("标签名");
    }
    console.log(errorList);
    if (!this.tag_id) {
      if (errorList.length == 0) {
        await dispatchGetSgameSkinTabList(store, {
          project: this.localProject,
          tab_name: this.tag_name,
          start_date: startTimeAll,
          end_date: endTimeAll,
          skin_list: this.checkedNodes.map((item) => item.id),
          //    project: 34,
          // tab_name: "皮肤页签1",
          // start_date: "2022-06-30",
          // end_date: "2022-06-30",
          // skin_list: [10502, 11301, 13200]
        });
        ElMessage.success({
          message: "创建标签成功",
          showClose: true,
          type: "success",
        });
      } else {
        let error_text = "";
        errorList.forEach((v, index) => {
          error_text += v + (index < errorList.length - 1 ? "," : "");
        });
        ElMessage.error(error_text + "不能为空");
        return;
      }
    } else {
      if (errorList.length == 0) {
        await dispatchUpdateSkinTab(store, {
          project: this.localProject,
          id: this.tag_id,
          tab_name: this.tag_name,
          start_date: startTimeAll,
          end_date: endTimeAll,
          skin_list: this.checkedNodes.map((item) => item.id),
        });
        ElMessage.success({
          message: "修改标签成功",
          showClose: true,
          type: "success",
        });
      } else {
        let error_text = "";
        errorList.forEach((v, index) => {
          error_text += v + (index < errorList.length - 1 ? "," : "");
        });
        ElMessage.error(error_text + "不能为空");
        return;
      }
    }
    await dispatchGetSgameSkinListGet(store, {
      project: this.localProject,
    });
    if (this.tag_list?.length == 0) {
      this.tree_show = true;
      this.text_cont = "";
    } else {
      this.tree_show = false;
      this.out_loading = true;

      this.text_cont = "展示";
      if (!this.tag_id) {
        this.tag_id = this.tag_list.filter(
          (v) => v.tab_name == this.tag_name
        )[0].id;
      }
      await this.dispatchGetSgameSkinData(store, {
        project: this.localProject,
        skin_tab_id: this.tag_id
          ? this.tag_id
          : this.tag_list.filter((v) => v.tab_name == this.tag_name)[0].id,
        filter: this.filter ? 'show1' : '',
      });
      this.get_skin();
    }

    this.out_loading = false;
  }
  public box_loading = false;
  public out_loading = false;
  public get dataSource() {
    return readGetSgameSkinOption(store);
  }

  private handleScroll() {
    requestAnimationFrame(this.fixedActiveBtn);
  }
  public checkedNodes = [];
  public handleCheckChange(node, checked, indeterminate) {
    const allCheckedNodes = (this.$refs.tree as any).getCheckedNodes();

    // 过滤出仅有children的节点，排除父节点
    this.checkedNodes = allCheckedNodes.filter((node) => {
      // 判断节点是否有子节点，如果没有子节点则保留
      return !node.children || node.children.length === 0;
    });
  }
  public text_cont = "展示";
  public fixedActiveBtn() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    const sidebar = document.getElementsByClassName("sidebar")[0];

    if (scrollTop >= 62) {
      sidebar.setAttribute(
        "style",
        "position:fixed;width: 220px;top:0px;background-color:#545c64;border: 0; overflow-x: hidden;"
      );
    } else {
      sidebar.setAttribute(
        "style",
        `position:fixed;width: 220px;top:${
          62 - scrollTop
        }px;background-color:#545c64;border: 0;`
      );
    }
  }
}
